import React, { useEffect, useState } from 'react';
import { InputNumber, Form, Modal, Button, Spin, Alert, Tag, Row, Col, Tooltip, Card, Timeline, Icon, Tabs, Skeleton, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { editInvoice, getInvoice } from './../API';
import { buildInvoicePDFTemplate } from './../utils/invoices';
import moment from 'moment';
import { format } from 'timeago.js';
import { formItemLayout, flexCenterLeft, flexCenterRight  } from './../theme';
import CustomAvatar from './../components/customAvatar';
import { s3 } from './../utils';
import parse from 'html-react-parser';
import { getCurrencySign } from './../utils/invoices';

import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons';
import { faFlagCheckered } from '@fortawesome/free-solid-svg-icons';
import { navigate } from "@reach/router"

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { sortBy } = require('lodash');

const { TabPane } = Tabs;

function Invoice(props) {
  const session = useMappedState(state => state.session);
  const dispatch = useDispatch();

  const [showConvertGBP, setShowConvertGBP] = useState(false);
  const [convertGBPValue, setConvertGBPValue] = useState(0);
  const [convertGBPLoading, setConvertGBPLoading] = useState(false);

  const [loading, setLoading] = useState(true);
  const [pdfURL, setPdfURL] = useState(null);
  const [noNamepdfURL, setNoNamepdfURL] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await getInvoice(session.authToken, props.id);
      setInvoice(response.data.invoice);
      setUsers(response.data.users);
      setLoading(false);

      const template = await buildInvoicePDFTemplate(response.data.invoice, false, false);
      const noNameTemplate = await buildInvoicePDFTemplate(response.data.invoice, false, true);

      pdfMake.createPdf(template).getBuffer((buffer) => {
        const dataUrl = URL.createObjectURL(new Blob([buffer], {
          type: "application/pdf"
        }));
        setPdfURL(dataUrl);
      });

      pdfMake.createPdf(noNameTemplate).getBuffer((buffer) => {
        const dataUrl = URL.createObjectURL(new Blob([buffer], {
          type: "application/pdf"
        }));
        setNoNamepdfURL(dataUrl);
      });

    }
    dispatch({ type: "SET_INDEX", payload: "11" });
    fetchData();
  // eslint-disable-next-line
  }, []);

  const renderCandidate = () => {
    return(
      <span style={{cursor: "pointer"}} onClick={() => {
        navigate(`/candidates/${invoice.candidate_docs.id}`)
      }}>
      <CustomAvatar
        colourCode={invoice.candidate_docs.firstname.charAt(0).toLowerCase()}
        char={`${invoice.candidate_docs.firstname.charAt(0).toUpperCase()}${invoice.candidate_docs.lastname.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${invoice.candidate_docs.id}.jpeg`} 
        />
      &nbsp;
      <span style={{fontWeight: 400}}>{invoice.candidate_docs.firstname} {invoice.candidate_docs.lastname}</span>
      &nbsp;
      </span>
    )
  }

  const renderClient = () => {
    return(
      <span style={{cursor: "pointer"}} onClick={() => {
        navigate(`/clients/${invoice.client_docs.id}`)
      }}>
      <CustomAvatar
        colourCode={invoice.client_docs.name.charAt(0).toLowerCase()}
        char={`${invoice.client_docs.name.charAt(0).toUpperCase()}`}
        charSize={13}
        size={26}
        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/client/${invoice.client_docs.id}.jpeg`} 
        />
      &nbsp;
      <span style={{fontWeight: 400}}>{invoice.client_docs.name}</span>
      &nbsp;
      &nbsp;
      </span>
    )
  }

  const renderContacts = () => {
    const contactArr = [invoice.contact_docs];
    if (invoice.additionalContact_docs) {
      contactArr.push(invoice.additionalContact_docs);
    }
    return(
      contactArr.map(i =>
        <span key={i.id} style={{cursor: 'pointer'}} onClick={() => {
          navigate(`/contacts/${i.id}`)
        }}>
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={`${i.firstname} ${i.lastname}`}
            style={{
              marginLeft: "-15px",
              position: "relative",
              border: "1px solid #fff",
              overflow: "hidden",
            }}
            colourCode={i.firstname.charAt(0).toLowerCase()}
            char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/contact/${i.id}.jpeg`}
          />
        </span>
      )
    )
  }

  const getIcon = (type) => {
    switch(type) {
      case 'on-board':
        return <FontAwesomeIcon icon={faStar} style={{fontSize: "16px", color: '#FB607F'}} />;
      case 'send-invoice':
        return <FontAwesomeIcon icon={faReceipt} style={{fontSize: "16px", color: '#B284BE'}} />;
      case 'check-payment':
        return <FontAwesomeIcon icon={faPiggyBank} style={{fontSize: "16px", color: '#FF8C00'}} />;
      case 'finish-rebate':
        return <FontAwesomeIcon icon={faFlagCheckered} style={{fontSize: "16px", color: '#FB607F'}} />;
      default:
        return <Icon type="clock-circle-o" style={{ fontSize: '16px' }} />;
    }
  }

  const renderReminder = (reminder) => {
    if (reminder.type === 'contact-candidate') {
      return(
        <div>
          {
            moment(invoice.onBoard).add(reminder.offset, 'days') < moment() ? (
              <>
              <Tooltip title="No Action">
                <FontAwesomeIcon icon={faTimesCircle} style={{fontSize: "16px", color: 'red'}} />
              </Tooltip>
              &nbsp;
              </>
            ) : null
          }
          Contact&nbsp;{renderCandidate()}
        </div>)
    }
    if (reminder.type === 'send-invoice') {
      return(
        <div>
          {
            moment(invoice.onBoard).add(reminder.offset, 'days') < moment() ? (
              <>
              <Tooltip title="No Action">
                <FontAwesomeIcon icon={faTimesCircle} style={{fontSize: "16px", color: 'red'}} />
              </Tooltip>
              &nbsp;
              </>
            ) : null
          }
          Send invoice to {renderClient()}
        </div>
      )
    }
    if (reminder.type === 'check-payment') {
      return(
        <div>
          {
            moment(invoice.onBoard).add(reminder.offset, 'days') < moment() ? (
              <>
              <Tooltip title="No Action">
                <FontAwesomeIcon icon={faTimesCircle} style={{fontSize: "16px", color: 'red'}} />
              </Tooltip>
              &nbsp;
              </>
            ) : null
          }
          Check payment
        </div>
      )
    }
  }

  const renderReminderEventTitle = (reminder) => {
    if (reminder.type === 'contact-candidate') {
      return(<div>
        <FontAwesomeIcon icon={faCheckCircle} style={{fontSize: "16px", color: '#8DB600'}} /> Contact {renderCandidate()}
        </div>)
    }
    if (reminder.type === 'send-invoice') {
      return(<div>
        <FontAwesomeIcon icon={faCheckCircle} style={{fontSize: "16px", color: '#8DB600'}} /> Send invoice to {renderClient()}&nbsp;&nbsp;&nbsp;{renderContacts()}
      </div>)
    }
    if (reminder.type === 'check-payment') {
      return(<div><FontAwesomeIcon icon={faCheckCircle} style={{fontSize: "16px", color: '#8DB600'}} /> Payment received</div>)
    }
  }

  const renderReminderEventTitleRight = (reminder) => {
    if (reminder.type === 'check-payment') {
      return(
        <b>
          <Tag color="#f50">{getCurrencySign(invoice.actualCurrency)}{(invoice.actualFee).toLocaleString()}</Tag>
        </b>
      )
    }
  }

  const renderReminderEventBody = (reminder) => {
    const found = invoice.events.find((i) => i._id === reminder.event);
    if (reminder.type === 'contact-candidate') {
      return(<div>
        {found.body ? parse(found.body) : <i style={{color: '#ccc'}}>Empty</i>}
      </div>)
    }
    if (reminder.type === 'send-invoice') {
      const found = invoice.events.find((i) => i._id === reminder.event);
      return(
        <div>
          {found.body ? parse(found.body) : <i style={{color: '#ccc'}}>Empty</i>}
        </div>
      )
    }
    if (reminder.type === 'check-payment') {
      const found = invoice.events.find((i) => i._id === reminder.event);
      return(
        <div>
          {found.body ? parse(found.body) : <i style={{color: '#ccc'}}>Empty</i>}
        </div>
      )
    }
  }

  const renderEventFooter = (reminder) => {
    const foundEvent = invoice.events.find((i) => i._id === reminder.event);
    const foundUser = users.find((i) => i._id === foundEvent.user);
    return(
      <>
      <Row style={{marginRight: '10px'}}>
        <Col span={24} style={flexCenterRight}>
          operated by
          &nbsp;
          <CustomAvatar
            colourCode={foundUser.firstname.charAt(0).toLowerCase()}
            char={`${foundUser.firstname.charAt(0).toUpperCase()}${foundUser.lastname.charAt(0).toUpperCase()}`}
            charSize={13}
            size={26}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${foundUser.id}.jpeg`} 
            />
          &nbsp;
          {foundUser.firstname} {foundUser.lastname}
          &nbsp;
          <i style={{fontSize: '12px', color: '#ccc'}}>
            {format(new Date(moment(foundEvent.createdAt).format('YYYY-MM-DD HH:mm:ss')))}
          </i>
        </Col>
      </Row>
      </>
    )
  }

  const renderContent = (reminder) => {
    if (reminder.type === 'on-board') {
      return(<div>
        {renderCandidate()}on board
      </div>)
    }
    else if (reminder.type === 'finish-rebate') {
      return(<div>{renderCandidate()}rebate days finished, Congratulations!</div>)
    }
    else {
      if (reminder.isRead) {
        return(
          <Card
            actions={[
              <>{renderEventFooter(reminder)}</>
            ]}
            size="small"
            title={
            <div style={flexCenterLeft}>{
              renderReminderEventTitle(reminder)
            }</div>
            } 
            extra={
              renderReminderEventTitleRight(reminder)
            }
            style={{ width: '525px' }}
          >
            <div>
              {renderReminderEventBody(reminder)}
            </div>
          </Card>
        )
      }
      return(
        <div>
          {renderReminder(reminder)}
        </div>
      )
    }
  }

  const renderTimeLine = (invoice, i, k) => {
    if (i._id === "offer") {
      return (
        <Timeline.Item key={i._id} >
          <div style={k%2 !== 0 ? flexCenterRight : flexCenterLeft}>
            <div style={{marginTop: '5px'}}>
              <Card size="small" bordered={true} title="Offer">
                <div style={{margin: '5px 0px 5px 0px'}}>
                  <span style={{fontWeight: 600}}>Salary</span>: {getCurrencySign(invoice.offer_docs.currency)}{invoice.offer_docs.salary.toLocaleString()} / monthly
                </div>
                {
                  invoice.offer_docs.signOnBonus && invoice.offer_docs.signOnBonus !== '' ? (
                    <div style={{margin: '5px 0px 5px 0px'}}>
                      <span style={{fontWeight: 600}}>Sign On Bonus</span>: {invoice.offer_docs.signOnBonus.toLocaleString()}
                    </div>
                  ) : null
                }
                {
                  invoice.offer_docs.bonus && invoice.offer_docs.bonus !== '' ? (
                    <div style={{margin: '5px 0px 5px 0px'}}>
                      <span style={{fontWeight: 600}}>Bonus</span>: {invoice.offer_docs.bonus}
                    </div>
                  ) : null
                }
                {
                  invoice.offer_docs.relocationAllowance && invoice.offer_docs.relocationAllowance !== '' ? (
                    <div style={{margin: '5px 0px 5px 0px'}}>
                      <span style={{fontWeight: 600}}>Relocation Allowance</span>: {invoice.offer_docs.relocationAllowance}
                    </div>
                  ) : null
                }
              </Card>
            </div>
          </div>
        </Timeline.Item>
      )
    }
    return (
      <Timeline.Item key={i._id} dot={getIcon(i.type)}>
        {moment(invoice.onBoard).add(i.offset, 'days').format('YYYY-MM-DD dddd')}&nbsp;
        <i style={{color: `${moment(invoice.onBoard).add(i.offset, 'days') > moment() ? '#B0BF1A' : '#ccc'}`}}>
          ({format(new Date(moment(invoice.onBoard).add(i.offset, 'days')))})
        </i>
        <div style={k%2 !== 0 ? flexCenterRight : flexCenterLeft}>
          <div style={{marginTop: '5px'}}>
            {
              renderContent(i)
            }
          </div>
        </div>
      </Timeline.Item>
    )
  }

  let timeLineData;
  if (invoice && invoice.offer_docs) {
    timeLineData = [...[{_id: 'offer', offset: -100}], ...invoice.reminders];
  } 
  
  if (invoice && !invoice.offer_docs) {
    timeLineData = invoice.reminders;
  }

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <div>
      <Modal
        centered={true}
        title="Convert Great British Pounds (GBP)"
        closable={false}
        visible={showConvertGBP}
        width="60%"
        footer={[
          <Button disabled={convertGBPLoading} key="cancel" onClick={() => {
            setShowConvertGBP(false);
            setConvertGBPValue(0);
          }}>
            <Icon type="close" />
            Cancel
          </Button>,
          <Button disabled={convertGBPLoading} key="edit" type="primary" onClick={async () => {
            setConvertGBPLoading(true);
            const result = await editInvoice(
              session.authToken,
              {
                type: 'convertGBP',
                id: props.id,
                convertGBP: convertGBPValue,
              }
            );
            // refresh invoice page
            const response = await getInvoice(session.authToken, props.id);
            setInvoice(response.data.invoice);
      
            setShowConvertGBP(false);
            setConvertGBPLoading(false);
            setConvertGBPValue(0);
            message.success(result.data.message);
          }}>
            {
              convertGBPLoading ?
              <Icon type="loading" />
              :
              <Icon type="check" />
            }
            Convert
          </Button>
        ]}
      >
        <Form.Item {...formItemLayout} label="Convert GBP">
          <InputNumber
            value={convertGBPValue}
            disabled={convertGBPLoading}
            placeholder="Please input here"
            style={{ width: '100%' }}
            min={0} max={1000000}
            onChange={(value) => {
              setConvertGBPValue(value);
            }}
          />
        </Form.Item>
      </Modal>
      <Tabs type="card" tabBarExtraContent={
        <>
          Created By&nbsp;
          <CustomAvatar
            showTooltip={true}
            tooltipTitle={invoice.user_docs.id === session.id ? "Me" : `${invoice.user_docs.firstname} ${invoice.user_docs.lastname}`}
            colourCode={invoice.user_docs.firstname.charAt(0).toLowerCase()}
            char={`${invoice.user_docs.firstname.charAt(0).toUpperCase()}${invoice.user_docs.lastname.charAt(0).toUpperCase()}`}
            charSize={12}
            size={30}
            src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${invoice.user_docs.id}.jpeg`}
          />
        {/*
        <Button size="small" type="primary" onClick={() => {
        }}><Icon type="pay-circle" />Refund</Button>
        */}
        </>
      }>
        <TabPane tab={<div><FontAwesomeIcon icon={faCalendarAlt} />&nbsp;&nbsp;Timeline</div>} key="1">
          <Spin spinning={!invoice.isActive} indicator={null} >
            <Row>
              <Col span={8}>
              {
                invoice.rebateTerm === 0 ? (
                  <Alert message="This invoice doesn't have rebate days!" type="info" showIcon />
                ) : null
              }
              </Col>
              <Col span={8} />
              <Col span={8} style={flexCenterRight} >
                {
                  invoice.paymentReceived && invoice.actualCurrency !== 'GBP' ? (
                    <div>
                      {
                        invoice.convertGBPDate ? (
                          <div>
                            <i style={{ fontSize: '12px', color: '#ccc' }}>
                              converted at {format(new Date(moment(invoice.convertGBPDate).format('YYYY-MM-DD HH:mm:ss')))}
                            </i>
                            &nbsp;
                            {
                              invoice.convertGBPRefund ? (
                                <Tag color="#f50"><b>£{(invoice.convertGBP - invoice.convertGBPRefund).toLocaleString()}</b></Tag>
                              ) : (
                                <Tag color="#f50"><b>£{invoice.convertGBP.toLocaleString()}</b></Tag>
                              )
                            }
                          </div>
                        ) : (
                          <Button onClick={() => {
                            setShowConvertGBP(true);
                          }}
                           type="primary"><Icon type="pay-circle" />Convert GBP</Button>
                        )
                      }
                    </div>
                  ) : null
                }
              </Col>
            </Row>
            <br />
            <Timeline mode="alternate">
              {
                sortBy(timeLineData, 'offset').map((i, k) => (
                  renderTimeLine(invoice, i, k)
                ))
              }
            </Timeline>
          </Spin>
        </TabPane>

        <TabPane tab={<div><FontAwesomeIcon icon={faFilePdf} />&nbsp;&nbsp;Invoice</div>} key="2">
          <Spin spinning={!invoice.isActive} indicator={null} >
          {
            pdfURL !== null ? (
              <iframe
                title="invoice"
                src={pdfURL}
                style={{ width: '100%', height: '1000px', border: 0 }}
              />
            ) : null
          }
          </Spin>
        </TabPane>

        <TabPane tab={<div><FontAwesomeIcon icon={faFilePdf} />&nbsp;&nbsp;Invoice Without Candidate Name</div>} key="3">
          <Spin spinning={!invoice.isActive} indicator={null} >
          {
            noNamepdfURL !== null ? (
              <iframe
                title="invoice"
                src={noNamepdfURL}
                style={{ width: '100%', height: '1000px', border: 0 }}
              />
            ) : null
          }
          </Spin>
        </TabPane>
      </Tabs>
    </div>
  )
}

export default Invoice;